export enum Currency {
    UNKNOWN = 0,
    CNY = 1,
    GBP = 2,
    USD = 3,
    HKD = 4,
    EUR = 5,
    AUD = 6,
    JPY = 7,
    MYR = 8,
    SGD = 9,
    THB = 10,
    YEN = 11,
    CAD = 12,
    NOK = 13,
    SEK = 14,
    CHF = 15,
    NZD = 16,
    ZAR = 17,
    KRW = 18,
    IDR = 19,
    VND = 20,
    MMK = 21,
    INR = 22,
    BRL = 23,
    UST = 24,
    BDT = 25,
    KHR = 26,
}
